
/**
 * 강의 콘텐츠 유형
 */
export type CreateCourseDraft201SectionsItemLecturesItemContentType = typeof CreateCourseDraft201SectionsItemLecturesItemContentType[keyof typeof CreateCourseDraft201SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  CODING: 'CODING',
} as const;
